import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSendMncmsMessage = (pregnancyId) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useMutation({
    mutationFn: async ({ consultationId, isCorrection = false }) => {
      const axios = createAxiosInstance();
      // A correction amends a message already sent to MN-CMS and must use the
      // dedicated endpoint (ActionType.UPDATE, OBR.25=C) — the create endpoint
      // 409s for an already-sent visit.
      const endpoint = isCorrection
        ? "send-mncms-correction"
        : "send-mncms-message";
      const response = await axios.post(
        `${tenantVal}/antenatalconsultation/${consultationId}/${endpoint}`
      );
      return response.data?.data ?? response.data;
    },
    onSuccess: (_data, variables) => {
      toast.success(
        variables?.isCorrection
          ? "Correction sent to Maternity Hospital."
          : "Message sent to Maternity Hospital."
      );
      queryClient.invalidateQueries({
        queryKey: ["anteNatalConsultations", pregnancyId, tenantVal],
      });
      // The outbound log is the source of truth for the "already sent" button
      // state, so refresh it once a (correction) send lands.
      queryClient.invalidateQueries({
        queryKey: ["mncmsOutboundMessages", pregnancyId, tenantVal],
      });
    },
    onError: (error) => {
      const isServiceUnavailable = error?.response?.status === 503;
      toast.error(
        isServiceUnavailable
          ? "Something went wrong during send to Maternity Hospital. Please try again."
          : error?.response?.data?.message ||
              "Failed to send to Maternity Hospital. Please try again."
      );
    },
    meta: { skipGlobalError: true },
  });
};
